import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'

import {Loader} from '../../utils/misc'
import CI from '../../utils/calendar'
import DateFormat from '../../utils/dateformat'
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment'

export default class SectionReceipt extends React.Component {

  constructor(props){
    super(props)
    this.handleReloadReceipts = this.handleReloadReceipts.bind(this)
    this.state = {showReceiptList:true}
  }

  handleReloadReceipts() {
    this.setState({showReceiptList:false})
    this.setState({showReceiptList:true})
  }

  render() {

    let invoice = this.props.invoice
    let addreceipt = <AddReceipt invoice={invoice} onAddCallback={this.handleReloadReceipts} />
    let receiptlist

    if(this.state.showReceiptList) {
      receiptlist = <ReceiptList invoice={invoice} />
    }

    return <div>
      <section className="medium">
        <h4>Add Receipt</h4>
      </section>
      <div className="row">
      <div className="col-md-12">
        {addreceipt}
      </div>


      </div>
      <section className="small">
        <h4>Receipts</h4>
        <div className="row">
          <div className="col-md-12">
            {receiptlist}
          </div>
        </div>
      </section>
      </div>

  }
}

class AddReceipt extends React.Component {

  constructor(props) {
    super(props)
    this.state = { receipt: {mode:"cash", amount:"", date_ui: moment(new Date()).format('YYYY-MM-DD'), date: moment(new Date()).format(), notes:"", reference:"", invoice:this.props.invoice}, loading:true}
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.submit = this.submit.bind(this)
    this.getReceipt = this.getReceipt.bind(this)

  }

  componentDidMount() {


    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.receipt_id !== "undefined") {
      this.setState({mode:'edit'})
      this.getReceipt(this.props.match.params.receipt_id).then((response)=>{
        if(response.status===200) {
          this.setState({receipt: response.data.receipt, loading:false})
        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }

    else {
        this.setState({loading:false})
    }

  }

  getReceipt(receipt_id) {
    return axios({
      url: '/get_receipt/?id='+receipt_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  submit() {
    this.setState({submitting:true})


    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_receipt/"
    }
    else {
      apiurl  = "/create_new_receipt/"
    }

    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.receipt
    }).then((response)=> {
      if(response.status === 200) {

        this.setState({receipt:response.data.receipt, submitting:false})
        if(typeof this.props.onAddCallback !== "undefined") {
        this.props.onAddCallback(response.data.receipt)
        }
        else {

          if(this.state.mode==="edit") {
            NotificationManager.success("Updated Receipt successfully")
          }
          else {
            NotificationManager.success("Created Receipt successfully")
          }

        }

      }
    }).catch((err)=> {
      console.log(err);
    })

  }

  handleInputChange(e) {
    var name = e.target.name
    var value = e.target.value
    let receipt = this.state.receipt
    receipt[name] = value
    this.setState({receipt:receipt})
  }

  handleDateChange(date) {
    let receipt = this.state.receipt

    receipt['date_ui'] = moment(date).format('YYYY-MM-DD')
    receipt['date'] = moment(date).format()
    this.setState({receipt:receipt})
  }

  render() {

    let submitButton = <button className="btn btn-success" onClick={this.submit}>Save</button>

    if(this.state.submitting) {
      submitButton = <button className="btn btn-success" disabled>Saving..</button>
    }

    if(this.state.loading) {
      return <Loader />
    }
    else {

        let receipt = this.state.receipt
        // let pageHeader
        // if(this.state.mode == "edit") {
        //   pageHeader = <h3>{"Edit Receipt  #" + receipt.serial}</h3>
        // }
        // else {
        //   pageHeader =  <h3 >Add Receipt</h3>
        // }

      return <div>

          <div className="form-horizontal">
              <div className="form-group">

                <div className="col-sm-6">
                Amount
                <input  type="text" name="amount" value={receipt.amount} onChange={this.handleInputChange} className="form-control input-sm" required />
                </div>

                <div className="col-sm-6">
                Payment Mode
                <select name="mode" value={receipt.mode} className="form-control input-sm" onChange={this.handleInputChange}>
                  <option value="cash" >CASH</option>
                  <option value="card">CARD</option>
                  <option value="cheque">CHEQUE</option>
                  <option value="banktransfer">BANK TRANSFER</option>
                  <option value="others">Others</option>
                </select>
                </div>
              </div>

              <div className="form-group">
              <div className="col-sm-6">
              Date
              <CI applyDate={this.handleDateChange} date={receipt.date_ui} />
              </div>

              <div className="col-sm-6">
              Reference
              <input  type="text" name="reference" value={receipt.reference} onChange={this.handleInputChange} className="form-control input-sm" />
              </div>
              </div>

              <div className="form-group">
               <div className="col-sm-12">
               Notes
                <textarea name="notes" className="form-control input-sm" value={receipt.notes} onChange={this.handleInputChange}></textarea>
               </div>
              </div>

                <div className="form-action-group text-center">
                    {submitButton}
              </div>
      </div></div>
    }


  }
}



class ReceiptList extends React.Component {


  constructor() {
    super();
    this.state = {
      tableState: {},
      data: [],
      pages: null,
      loading: true
    };
    this.fetchList = this.fetchList.bind(this)
    this.fetchData = this.fetchData.bind(this);
    this.deleteReceipt = this.deleteReceipt.bind(this)
    this.deleteFormat = this.deleteFormat.bind(this)
  }

    deleteReceipt(receipt_id) {

      axios({
        url: '/delete_receipt/',
        baseURL: API_BASE_URL,
        method:'post',
        data: {id:receipt_id},
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.fetchList()
      }).catch(err=>{
        console.log(err);
      })
    }

    fetchList(state=this.state.tableState) {

      this.setState({ loading: true });
      let apiurl = "/list_receipts/?invoice="+this.props.invoice+'&page=' + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.receipts,
          pages: res.data.pages,
          loading: false
        });
      });

    }

    fetchData(state, instance) {
      this.fetchList(state)
      this.setState({tableState: state})
    }

    deleteFormat(row) {
      return <button className="btn btn-sm btn-danger" onClick={e=>this.deleteReceipt(row.original.id)}>Delete</button>
    }


    render() {

      const { data, pages, loading } = this.state;
      const columns = [
        {Header:'Date',  accessor:'date',sortable:false,  Cell:(row)=>(<DateFormat date={row.original.date}/>)},
        {Header:'Amount',  accessor:'amount',sortable:true},
        {Header:'Mode', accessor: 'mode',sortable:false },
        {Header:'Reference', accessor: 'reference',sortable:false },
        {Header:'Notes', accessor: 'notes',sortable:false },
        {Header:'', Cell:(row)=>  {return this.deleteFormat(row)}}
      ]
      const defaultSort=[{id: "id", desc: true}]

      return <div>
      <section className="small">
      </section>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              noDataText="No Receipts Found."
                columns={columns} manual data={data} showPagination={false}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/invoice/receipt.js